import {useMutation} from 'react-query';
import {addCommentAnswer} from '../../../../services/comment';
import {useDispatch} from 'react-redux';
import {toggleModal} from '../../../../store/redux/postSuccessModal';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const UseAddCommentAnswer = (
  setShowAnswer: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = useDispatch();
  const {isLoading, mutate: addAnswer} = useMutation({
    mutationFn: (payload: IAddCommentAnswerPayload) => {
      return addCommentAnswer(payload);
    },
    onSuccess: () => {
      //   navigate('/home');
      setShowAnswer(false);
      dispatch(
        toggleModal({
          show: true,
          message: 'نظر شما با موفقیت ثبت گردید',
          description: '',
        }),
      );
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, addAnswer};
};

export default UseAddCommentAnswer;
